var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon icon__private--industry icon--style--fill icon--size--large",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M20 22.996H4a2 2 0 01-2-2 5 5 0 015-5h10a5 5 0 015 5 2 2 0 01-2 2zm-8-22c-3.038 0-5.5 2.6-5.5 6.331s1.839 7.169 5.5 7.169 5.5-3.441 5.5-7.169S15.038.996 12 .996z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }